import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { Observable } from 'rxjs/Observable';
import { of } from 'rxjs/observable/of';
import { catchError, map, tap } from 'rxjs/operators';

import { ComponentBaseService } from './component-base.service'
import { ServicesConstants } from '../services-constants'
import { StatoConsegna } from '../_models/stato-consegna';
import { Utils } from '../utils';
import { delayedRetry } from './delayed-retry';

@Injectable()
export class StatoConsegnaService extends ComponentBaseService {

  constructor(
    private http: HttpClient
  ) {
    super();
  }

  getServiceName(): string {
    return "StatoConsegnaService";
  }

  /** GET StatoConsegna by id. Will 404 if id not found */
  getElencoStatiConsegna(): Observable<StatoConsegna[]> {
    let url = `${ServicesConstants.URL_STATICONSEGNA}`;


    return this.http.get<StatoConsegna[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Stati Consegna`)),
      catchError(this.handleError<StatoConsegna[]>(`getElencoStatiConsegna`))
    );
  }

  /** GET StatoConsegna by id. Will 404 if id not found */
  getElencoStatiConsegnaByCod(codStatoConsegna: number): Observable<StatoConsegna[]> {
    let url = `${ServicesConstants.URL_STATICONSEGNA}?codStatoConsegna=${codStatoConsegna}`;


    return this.http.get<StatoConsegna[]>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Elenco Stati Consegna codStatoConsegna=${codStatoConsegna}`)),
      catchError(this.handleError<StatoConsegna[]>(`getElencoStatiConsegna`))
    );
  }

  /** GET StatoConsegna by id. Will 404 if id not found */
  getStatoConsegna(id: number): Observable<StatoConsegna> {
    const url = `${ServicesConstants.URL_STATICONSEGNA}/${id}`;
    return this.http.get<StatoConsegna>(url).pipe(
      delayedRetry(),
      tap(_ => this.log(`fetched Stato Consegna Locale id=${id}`)),
      catchError(this.handleError<StatoConsegna>(`getStatoConsegna id=${id}`))
    );
  }

  //////// Save methods //////////

  /** POST: add a new StatoConsegna to the server */
  addStatoConsegna(statoConsegna: StatoConsegna): Observable<StatoConsegna> {
    return this.http.post<StatoConsegna>(ServicesConstants.URL_STATICONSEGNA, statoConsegna, this.httpOptions).pipe(
      tap((StatoConsegna: StatoConsegna) => this.log(`added StatoConsegna Locale w/ id=${statoConsegna.codStatoConsegna}`)),
      catchError(this.handleError<StatoConsegna>('addStatoConsegna'))
    );
  }

  /** DELETABLE: delete the Documento from the server */
  isStatoConsegnaDeletable(statoConsegna: StatoConsegna | number): Observable<boolean> {
    const id = typeof statoConsegna === 'number' ? statoConsegna : statoConsegna.codStatoConsegna;
    const url = `${ServicesConstants.URL_STATICONSEGNA}/${id}?cmd=checkCancellabile`;

    return this.http.get<boolean>(url, this.httpOptions).pipe(
      delayedRetry(),
      tap(_ => this.log(`Deletable StatoConsegna id=${id}: ${_}`)),
      catchError(this.handleError<boolean>('isStatoConsegnaDeletable'))
    );
  }

  /** DELETE: delete the StatoConsegna from the server */
  deleteStatoConsegna(statoConsegna: StatoConsegna | number): Observable<StatoConsegna> {
    const id = typeof statoConsegna === 'number' ? statoConsegna : statoConsegna.codStatoConsegna
    const url = `${ServicesConstants.URL_STATICONSEGNA}/${id}`;

    return this.http.delete<StatoConsegna>(url, this.httpOptions).pipe(
      tap(_ => this.log(`deleted StatoConsegna Locale id=${id}`)),
      catchError(this.handleError<StatoConsegna>('deleteStatoConsegna'))
    );
  }

  /** PUT: update the StatoConsegna on the server */
  updateStatoConsegna(statoConsegna: StatoConsegna | number): Observable<any> {
    const id = typeof statoConsegna === 'number' ? statoConsegna : statoConsegna.codStatoConsegna;
    const url = `${ServicesConstants.URL_STATICONSEGNA}/${id}`;

    return this.http.put(url, statoConsegna, this.httpOptions).pipe(
      tap(_ => this.log(`updated StatoConsegna Locale id=${id}`)),
      catchError(this.handleError<any>('updateStatoConsegna'))
    );
  }

}


// WEBPACK FOOTER //
// ./src/app/_services/stato-consegna.service.ts